import { Footer } from "./Footer";
import { ModalWrapper } from "./ModalWrapper";

export function CliModal() {
  return (
    <ModalWrapper>
      <div style={{ width: "100%", textAlign: "center" }}>
        Waiting for token...
      </div>
      <Footer />
    </ModalWrapper>
  );
}
